// Target handles hovers over items and actions. Other visible
// items and actions with the same id will highlight. In some cases
// an event is generated inviting other pages to scroll the item
// into view. Target tracks hovering even when not requested so
// that highlighting can be immediate when requested.
//
// DISABLED: Shift+hover targeting (red .emit outlines, .target / .consumed
// highlights, cross-page align-item scroll) is unfinished and fights desktop
// Shift-copy item drag. Re-enable TARGETING_UI when the consume/emit
// relationship UX is designed properly.

const TARGETING_UI = false

let targeting = false
let $item = null
let item = null
let itemElem = null
let action = null
let consumed = null

const bind = function () {
  if (!TARGETING_UI) return
  $(document)
    .on('keydown', function (e) {
      if (e.keyCode === 16) {
        startTargeting(e)
      }
    })
    .on('keyup', function (e) {
      if (e.keyCode === 16) {
        stopTargeting(e)
      }
    })
  $('.main')
    .on('mouseenter', '.item', enterItem)
    .on('mouseleave', '.item', leaveItem)
    .on('mouseenter', '.action', enterAction)
    .on('mouseleave', '.action', leaveAction)
    .on('align-item', '.page', alignItem)
    .on('mouseenter', '.backlinks .remote', enterBacklink)
    .on('mouseleave', '.backlinks .remote', leaveBacklink)
}

var startTargeting = function (e) {
  targeting = e.shiftKey
  if (targeting && $item != null && $item.length != 0) {
    let id
    $('.emit').addClass('highlight')
    if ((id = item || action)) {
      $(`[data-id=${id}]`).addClass('target')
      const key = $(this).parents('.page:first').data('key')
      const place = $item.offset().top
      $('.page').trigger('align-item', { key, id: item, place })
    }
    if (itemElem) {
      consumed = itemElem.consuming
      if (consumed) {
        consumed.forEach(i => itemFor(i).addClass('consumed'))
      }
    }
  }
}

var stopTargeting = function (e) {
  targeting = e.shiftKey
  if (!targeting) {
    $('.emit').removeClass('highlight')
    $('.item, .action').removeClass('target')
    $('.item').removeClass('consumed')
  }
}

const pageFor = function (pageKey) {
  const $page = $('.page').filter((_i, page) => $(page).data('key') === pageKey)
  if ($page.length === 0) {
    return null
  }
  if ($page.length > 1) {
    console.log('warning: more than one page found for', pageKey, $page)
  }
  return $page
}

var itemFor = function (pageItem) {
  const [pageKey, item] = pageItem.split('/')
  const $page = pageFor(pageKey)
  if (!$page) {
    return null
  }
  $item = $page.find(`.item[data-id=${item}]`)
  if ($item.length === 0) {
    return null
  }
  if ($item.length > 1) {
    console.log('warning: more than one item found for', pageItem, $item)
  }
  return $item
}

var enterItem = function () {
  item = ($item = $(this)).attr('data-id')
  itemElem = $item[0]
  if (targeting) {
    $(`[data-id=${item}]`).addClass('target')
    const key = $(this).parents('.page:first').data('key')
    const place = $item.offset().top
    $('.page').trigger('align-item', { key, id: item, place })
    consumed = itemElem.consuming
    if (consumed) {
      consumed.forEach(i => itemFor(i).addClass('consumed'))
    }
  }
}

var leaveItem = () => {
  if (targeting) {
    $('.item, .action').removeClass('target')
    $('.item').removeClass('consumed')
  }
  item = null
  $item = null
  itemElem = null
}

var enterAction = function () {
  action = $(this).data('id')
  if (targeting) {
    $(`[data-id=${action}]`).addClass('target')
    const key = $(this).parents('.page:first').data('key')
    $('.page').trigger('align-item', { key, id: action })
  }
}

var leaveAction = () => {
  if (targeting) {
    $(`[data-id=${action}]`).removeClass('target')
  }
  action = null
}

var enterBacklink = function () {
  item = ($item = $(this)).attr('data-id')
  itemElem = $item[0]
  if (targeting) {
    $(`[data-id=${item}]`).addClass('target')
    const key = $(this).parents('.page:first').data('key')
    const place = $item.offset().top
    $('.page').trigger('align-item', { key, id: item, place })
  }
}

var leaveBacklink = () => {
  if (targeting) {
    $('.item, .action').removeClass('target')
  }
  item = null
  itemElem = null
}

var alignItem = function (e, align) {
  const $page = $(this)
  if ($page.data('key') === align.key) {
    return
  }
  $item = $page.find(`.item[data-id=${align.id}]`)
  if (!$item.length) {
    return
  }
  const place = align.place || $page.height() / 2
  const offset = $item.offset().top + $page.scrollTop() - place
  $page.stop().animate({ scrollTop: offset }, 'slow')
}

module.exports = { bind }
